import { createIcon } from '@chakra-ui/react';

export const SberIcon = createIcon({
  displayName: 'SberIcon',
  viewBox: '0 0 58 29',
  path: (
    <>
      <g clipPath='url(#clip0_365_32867)'>
        <path
          d='M28.9 16.0999V19.3999H27V8.8999H30.5C33.8 8.8999 35.2 10.0999 35.2 12.3999C35.2 14.7999 33.6 16.0999 30.5 16.0999H28.9ZM28.9 10.5999V14.3999H30.7C32.4 14.3999 33.3 13.7999 33.3 12.3999C33.3 11.0999 32.5 10.5999 30.7 10.5999H28.9Z'
          fill='white'
        />
        <path
          d='M36.2 12.4002C36.7 12.0002 37.6 11.7002 38.9 11.7002C41.1 11.7002 42.2 12.4002 42.2 14.4002V19.3002H40.5999V18.0002C40.1999 18.9002 39.2999 19.5002 38.0999 19.5002C36.5999 19.5002 35.7 18.6002 35.7 17.2002C35.7 15.5002 36.8999 15.0002 38.7999 15.0002H40.5V14.7002C40.5 13.6002 40 13.3002 39 13.3002C37.6 13.3002 36.7999 13.8002 36.2999 14.6002L36.2 12.4002ZM40.4 16.7002V16.1002H38.9C37.9 16.1002 37.4 16.3002 37.4 17.0002C37.4 17.6002 37.7999 17.9002 38.5999 17.9002C39.7999 17.9002 40.3 17.2002 40.4 16.7002Z'
          fill='white'
        />
        <path
          d='M43 11.8003H44.9L46.9 16.9003L48.6 11.8003H50.4L47.4 20.0003C46.7 21.8003 46.1 22.2003 45.1 22.2003C44.6 22.2003 44.1 22.1003 43.9 21.9003V20.3003C44.1 20.5003 44.5 20.7003 44.8 20.7003C45.3 20.7003 45.7 20.3003 46 19.3003L43 11.8003Z'
          fill='white'
        />
        <path
          d='M11.7 12.4002V14.7002L14.7 16.6002L22 11.3002C21.7 10.7002 21.4 10.2002 21 9.7002L14.7 14.3002L11.7 12.4002Z'
          fill='white'
        />
        <path
          d='M20.8999 14.3001V14.5001C20.8999 15.9001 20.3999 17.2001 19.5999 18.3001C18.7999 19.4001 17.5999 20.1001 16.1999 20.5001C14.8999 20.8001 13.4999 20.7001 12.1999 20.1001C10.8999 19.5001 9.8999 18.6001 9.2999 17.4001C8.6999 16.2001 8.3999 14.8001 8.6999 13.4001C8.8999 12.0001 9.5999 10.8001 10.6999 9.9001C11.6999 9.0001 12.9999 8.4001 14.3999 8.4001C15.7999 8.3001 17.0999 8.7001 18.2999 9.5001L19.8999 8.4001C18.4999 7.3001 16.6999 6.6001 14.8999 6.6001C13.0999 6.6001 11.2999 7.2001 9.8999 8.3001C8.4999 9.4001 7.4999 11.0001 7.0999 12.8001C6.6999 14.6001 6.8999 16.4001 7.6999 18.0001C8.4999 19.6001 9.7999 21.0001 11.3999 21.7001C12.9999 22.5001 14.8999 22.7001 16.5999 22.3001C18.3999 21.9001 19.8999 20.9001 21.0999 19.5001C22.1999 18.1001 22.7999 16.3001 22.7999 14.5001C22.7999 14.0001 22.7999 13.5001 22.6999 13.1001L20.8999 14.3001Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_365_32867'
          x1='12.5315'
          y1='33.1904'
          x2='45.1205'
          y2='-3.78401'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C7E701' />
          <stop offset='0.2424' stopColor='#0ADA01' />
          <stop offset='0.4393' stopColor='#21DE58' />
          <stop offset='0.6317' stopColor='#3EE3A9' />
          <stop offset='0.8075' stopColor='#37DABE' />
          <stop offset='1' stopColor='#15CAE0' />
        </linearGradient>
      </defs>
    </>
  ),
});
